import {icons} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import {raise} from '@yandex-delivery/utils'
import React from 'react'
import {Redirect, useHistory} from 'react-router-dom'

import type {TariffData, TariffsCountry, TariffsZone} from '../../../api'
import {Header} from '../../../components/Header/Header@desktop'
import {useConfig} from '../../../config'
import type {PathWithCountry} from '../../../types'
import type {Resource} from '../../../utils'
import {ExactPriceBlock} from '../components/ExactPriceBlock/ExactPriceBlock@desktop'
import {CargoInfoContainer, NddInfoContainer} from '../components/Info/desktop'
import {Message} from '../components/Message/Message@desktop'
import {TariffsList} from '../components/TariffsList/TariffsList@desktop'
import styleClasses from './classes.module.css'

export type TariffsPageProps = {
  path: PathWithCountry
  resource: Resource<TariffData>
  countries: TariffsCountry[]
  cities: TariffsZone[]
}

const InfoComponents = {
  ndd: NddInfoContainer,
  cargo: CargoInfoContainer,
}

export function TariffsPage({path, resource, countries, cities}: TariffsPageProps) {
  const {getPath} = useConfig()
  const {tariff, city} = path

  const {messages, tariffs} = resource.read()

  const {push} = useHistory()
  const i18n = useI18n()

  const currentTariff = tariffs.find(({id}) => id === tariff)

  if (!tariff || !currentTariff) {
    return <Redirect to={getPath({...path, tariff: tariffs[0]?.id || raise('Tariffs list is empty')})} />
  }

  const citiesLinkClickHandler = () => {
    push(getPath({country: path.country}))
  }

  const currentCity = cities.find(({id}) => id === city) || raise(`Incorrect city id: ${city}`)

  const InfoComponent = InfoComponents[currentTariff.type]

  return (
    <div className={styleClasses.page}>
      <Header
        countries={countries}
        path={path}
        subtitle={
          <div className={styleClasses.breadCrumbs}>
            <Typography
              className={styleClasses.citiesLink}
              color="textMinor"
              density="normal"
              level="title4"
              weight="bold"
            >
              <span onClick={citiesLinkClickHandler}>{i18n('tariffs-v3.header.link-to-cities', 'Все города')}</span>
            </Typography>

            <icons.ChevronRight className={styleClasses.chevron} />

            <Typography density="normal" level="title4" weight="bold">
              {currentCity.title}
            </Typography>
          </div>
        }
      />

      {messages.map(message => (
        <Message key={message.title} message={message} />
      ))}

      <div className={styleClasses.pageContent}>
        <div className={styleClasses.listContainer}>
          <TariffsList path={path} tariffs={tariffs} />
          <ExactPriceBlock />
        </div>

        <InfoComponent key={currentTariff.id} city={currentCity} path={path} tariff={currentTariff} />
      </div>
    </div>
  )
}
